import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import type { BillboardListResponse } from '@/features/billboards/utils/billboardsListUtils';

export type WishlistListFilter = {
  page: number;
  limit: number;
};

export async function fetchWishlist(params: WishlistListFilter) {
  const { data } = await httpClient.get<BillboardListResponse>(
    endpoints.wishlist.list,
    { params },
  );
  return data;
}

export async function toggleWishlist(billboardId: string) {
  const { data } = await httpClient.patch(endpoints.wishlist.toggle, {
    billboardId,
  });
  return data;
}
